import prepareActionTypes from '../../helpers/prepareActionTypes';

export default prepareActionTypes(
  {
    SYMBOLS: {
      INVALID: '',
      REQUESTING: '',
      FAILURE: '',
      SUCCESS: '',
    },
    LOAD: {
      INVALID: '',
      REQUESTING: '',
      FAILURE: '',
      SUCCESS: '',
    },
    SET: {
      LOCATION: '',
      PREFIX: '',
      USER_AGENT: '',
      COOKIES: '',
      MENU_VISIBLE: '',
      THEME: '',
    },
  },
  ['DATA']
);
